import { PrinterIcon } from "assets/icon/PrinterIcon"

export const GridPrintButton = ({ onClick, size = 'w-4', status = '1' }) => {
    return (
        <button className="p-2 bg-black rounded-lg flex gap-2" onClick={onClick}>
            <PrinterIcon className={`fill-white ${size}`} />
        </button>
    )
}